import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import NewServicemen from "../components/NewServicemen";

const NewServicemenPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='All Servicemen ' />

                <NewServicemen />

            </MasterLayout>
        </>
    );
};

export default NewServicemenPage;
